<!-- 组件说明 -->
<template>
  <div class="">
    <div class="btn-line">
      <div class="button">
        <img src="~/common/images/recommend/delete-icon.png" class="btn-icon" />
        <div class="btn-content" @click="isRecycleBin = !isRecycleBin">
          回收站
        </div>
      </div>
    </div>
    <owner-info
      v-if="!isRecycleBin"
      :projectCode="projectCode"
      :orgCode="orgCode"
    />
    <recycle-bin
      v-if="isRecycleBin"
      :projectCode="projectCode"
      :orgCode="orgCode"
    />
  </div>
</template>

<script>
import OwnerInfo from "./OwnerInfo";
import RecycleBin from "./RecycleBin";
export default {
  props: {
    projectCode: {
      type: String,
    },
    orgCode: {
      type: String,
    },
  },
  components: { OwnerInfo, RecycleBin },
  data() {
    return {
      // 是否为回收站页面
      isRecycleBin: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.btn-line {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  .button {
    display: flex;
    width: 140px;
    height: 48px;
    border-radius: 24px;
    border: 2px solid #0d9869;
    justify-content: space-around;
    align-items: center;
    .btn-content {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0d9869;
    }
    .btn-icon {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
